(function () {
  if (window.sipOkendoRatingsInstalled) return;
  window.sipOkendoRatingsInstalled = true;
  const SNIPPET_SELECTOR = '.okendo-StarRatingSnippet, .okendo-ProductListingSnippet';
  const RENDERED_SELECTOR = '.oke-sr, .oke-stars, .okeReviews';
  const PROCESSED_ATTR = 'data-oke-sanitized';
  const pending = new Set();
  let sanitizeTimer;
  let initTimer;
  let needsNativeInit = false;

  function parseReviewPayload(el) {
    const script = el.querySelector("script[data-oke-metafield-data], script[type='application/json']");
    const text = script ? script.textContent : (el.textContent || '').trim();
    if (!script && text.charAt(0) !== '{') return null;
    try { return JSON.parse(text); } catch (error) { return null; }
  }

  function productIdFrom(el) {
    const item = el.closest('.boost-sd__product-item, .boost-sd__suggestion-queries-item--product, [data-product-id]');
    return item ? item.getAttribute('data-product-id') || item.getAttribute('data-id') || '' : '';
  }

  function hideSnippet(el) {
    el.textContent = '';
    el.setAttribute('hidden', '');
    el.style.display = 'none';
    el.setAttribute(PROCESSED_ATTR, '');
  }

  function promoteToWidget(el, productId, payload) {
    el.removeAttribute('hidden');
    el.style.removeProperty('display');
    el.setAttribute('data-oke-star-rating', '');
    if (productId) el.setAttribute('data-oke-reviews-product-id', 'shopify-' + productId);
    if (payload) el.textContent = JSON.stringify(payload);
    el.setAttribute(PROCESSED_ATTR, '');
  }

  function sanitize(el) {
    if (!el.isConnected || el.hasAttribute(PROCESSED_ATTR)) return false;
    const productItem = el.closest('.boost-sd__product-item, .boost-sd__suggestion-queries-item--product');
    if (el.matches('.okendo-ProductListingSnippet') && productItem?.querySelector('.okendo-StarRatingSnippet')) {
      hideSnippet(el);
      return false;
    }
    if (el.querySelector(RENDERED_SELECTOR)) {
      el.removeAttribute('hidden');
      el.style.removeProperty('display');
      el.setAttribute(PROCESSED_ATTR, '');
      return false;
    }
    const payload = parseReviewPayload(el);
    const valid = payload && typeof payload === 'object' &&
      (payload.reviewCount != null || payload.reviewAverageValue != null || payload.averageRating != null);
    const count = valid ? Number(payload.reviewCount || 0) : null;
    const productId = productIdFrom(el);
    if (count === 0) { hideSnippet(el); return false; }
    const text = (el.textContent || '').trim();
    if (count > 0 || (!text && /^\d+$/.test(productId))) {
      promoteToWidget(el, productId, count > 0 ? payload : null);
      return true;
    }
    if (!text) hideSnippet(el);
    return false;
  }

  function flush() {
    sanitizeTimer = null;
    let needsInit = false;
    for (const el of pending) needsInit = sanitize(el) || needsInit;
    pending.clear();
    if (!needsInit) return;
    needsNativeInit = true;
    requestInit();
  }

  function requestInit() {
    clearTimeout(initTimer);
    initTimer = setTimeout(function () {
      if (needsNativeInit && window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
        needsNativeInit = false;
        window.okeWidgetApi.initAllWidgets();
      }
    }, 50);
  }

  function collect(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9) || !root.querySelectorAll) return;
    if (root.matches?.(SNIPPET_SELECTOR) && !root.hasAttribute(PROCESSED_ATTR)) pending.add(root);
    root.querySelectorAll(SNIPPET_SELECTOR).forEach(function (el) {
      if (!el.hasAttribute(PROCESSED_ATTR)) pending.add(el);
    });
    if (pending.size && !sanitizeTimer) sanitizeTimer = setTimeout(flush, 50);
  }

  function ready() {
    collect(document);
    new MutationObserver(function (records) {
      for (const record of records) {
        if (record.target.nodeType === 1 && record.target.matches?.(SNIPPET_SELECTOR)) collect(record.target);
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && !node.closest?.('[data-sip-ls-fallback], [data-sip-review-snapshot]')) collect(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('oke-script-loaded', function () {
      if (needsNativeInit) requestInit();
      if (pending.size && !sanitizeTimer) sanitizeTimer = setTimeout(flush, 50);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  window.sanitizeOkendoStarRatings = function (root) { collect(root || document); };
})();
